module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content container"
  }, [_c('h3', {
    staticClass: "text-center text-regular mb20"
  }, [_vm._v("Upload your designs")]), _vm._v(" "), _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "projectDesignerFilesUpload",
      "url": "/upload/file",
      "useCustomDropzoneOptions": "",
      "dropzoneOptions": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-removed-file": _vm.onFileRemove,
      "vdropzone-sending": _vm.onSending,
      "vdropzone-queue-complete": _vm.onUploaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center mt20"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 mr5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'btn--disabled': _vm.uploading
    },
    attrs: {
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Submit\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea562c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/task/modals/UploadDesignerFilesModal.vue
// module id = 453
// module chunks = 2